/* eslint-disable max-len */
export default {
  'center-area-script-name': 'My first script',
  'center-area-new-script-name': 'My new Script',
  'center-area-run': 'Run script',
  'center-area-link-card': 'Link Oxocard',
  'center-area-upload': 'Stage program',
  'center-area-state-compile': 'Compiling',
  'center-area-state-link': 'Linking',
  'center-area-state-finish': 'Finished',
  'center-area-button-new': 'New',
  'center-area-button-save': 'Save',
  'center-area-button-open': 'Open',
  'center-area-button-share': 'Share',

  'left-area-toggle-button': 'Minimize',
  'left-area-button-settings': 'Settings',

  toolbox_button_create_variable: 'New Variable',
  toolbox_category_logic: 'Logic',
  toolbox_category_variables: 'Variables',
  toolbox_category_procedures: 'Functions',
  toolbox_category_time: 'Time',
  toolbox_category_weather: 'Weather',
  toolbox_category_oxocard: 'Oxocard',
  toolbox_category_matrix: 'Matrix',
  toolbox_category_communication: 'Communication',
  toolbox_category_accelerometer: 'Accelerometer',
  toolbox_category_bluetooth: 'Bluetooth',
  toolbox_category_speaker: 'Speaker',
  toolbox_category_microphone: 'Microphone',
  toolbox_category_extras: 'Extras',

  toolbox_label_simple: '---------------------------------------------- Simple blocks ----------------------------------------------',
  toolbox_label_advanced: '-------------------------------------------- Advanced blocks --------------------------------------------',
  toolbox_label_expert: '---------------------------------------------- Expert blocks ----------------------------------------------',
  toolbox_logic_label_conditions: '------------------------------------------- Conditions blocks -------------------------------------------',
  toolbox_logic_label_loops: '----------------------------------------------- Loop blocks -------------------------------------------------',
  toolbox_variables_label_variables: '-------------------------------------------- Variable blocks ----------------------------------------------',
  toolbox_variables_label_calculation_and_allocation: '------------------------------ Calculation and allocation blocks -------------------------------',
  toolbox_variables_label_functions: '-------------------------------------------- Function blocks ---------------------------------------------',
  toolbox_variables_label_lists: '----------------------------------------------- List blocks --------------------------------------------------',
  toolbox_variables_label_pus: '----------------------------------- Persistent Memory blocks --------------------------------------',
  toolbox_oxocard_label_on_off: '--------------------------------------------- On/Off blocks -----------------------------------------------',
  toolbox_oxocard_label_sensors: '--------------------------------------------- Sensor blocks -----------------------------------------------',
  toolbox_oxocard_label_update_mode: '---------------------------------------- Update mode blocks -----------------------------------------',
  toolbox_matrix_label_colors: '---------------------------------------------- Color blocks -------------------------------------------------',
  toolbox_matrix_label_set_pixels: '-------------------------------------------- Set pixel blocks ---------------------------------------------',
  toolbox_matrix_label_graphics: '--------------------------------------------- Graphic blocks ----------------------------------------------',
  toolbox_matrix_label_text: '----------------------------------------------- Text blocks -------------------------------------------------',
  toolbox_matrix_label_frame_buffer: '---------------------------------------- Frame buffer blocks ------------------------------------------',
  toolbox_matrix_label_get_pixels: '------------------------------------------- Get pixel blocks ----------------------------------------------',
  toolbox_time_label_time: '---------------------------------------------- Time blocks --------------------------------------------------',
  toolbox_time_label_online_time: '------------------------------------------ Online time blocks --------------------------------------------',
  toolbox_communication_label_general: '--------------------------------------------- General blocks ----------------------------------------------',
  toolbox_speaker_label_play_tone: '-------------------------------------------- Play tone blocks ---------------------------------------------',
  toolbox_speaker_label_configure_tone: '---------------------------------------- Configure tone blocks ----------------------------------------',
  toolbox_speaker_label_volume: '---------------------------------------------- Volume blocks ----------------------------------------------',
  toolbox_speaker_label_sound_effect: '----------------------------------------- Sound effect blocks -----------------------------------------',
  toolbox_extras_label_gpios: '------------------------------------------------ GPIO blocks -----------------------------------------------',
  toolbox_extras_label_console: '---------------------------------------------- Console blocks ----------------------------------------------',
  toolbox_extras_label_push_values: '------------------------------------------------ Data blocks ------------------------------------------------',
  toolbox_extras_label_i2c: '------------------------------------------------- I2C blocks --------------------------------------------------',

  'right-area-news': 'Read now (News)',
  'right-area-instructions': 'Instructions',
  'right-area-simulator': 'Simulator',
  'right-area-my-oxocards': 'My Oxocard',
  'right-area-worksheets': 'Worksheets',
  'right-area-booklet-examples': 'Book (german): Achtung, fertig, Code!',
  'right-area-examples': 'Examples',
  'right-area-blockly-console': 'Console',
  'right-area-blockly-variables': 'Data',
  'right-area-source-code': 'Source code',
  'right-area-feedback': 'Feedback',
  'right-area-feedback-mail-to': 'Send us an email',
  'right-area-feedback-imprint': 'Imprint',
  'right-area-feedback-imprint-href': 'https://oxocard.ch/de/imprint/',

  'right-area-toggle-button': 'Minimize',
  'right-area-show': 'Show',
  'right-area-template': 'Template',
  'right-area-solution': 'Solution',

  'right-area-simulator-reset': 'Restart card',
  simulator_unknown_function: 'is not supported by the simulator',
  simulator_compile_error: 'Error in the program',

  'right-area-my-oxocard-no-card': 'You haven\'t connected a card.',
  'right-area-my-oxocard-card-connected': 'You\'re connected with {{CARD_NAME}}.',
  'right-area-my-oxocard-connect-card': 'Link Oxocard',
  'right-area-my-oxocard-other-card': 'Link another Oxocard',
  'right-area-my-oxocard-default-image': 'Reset to inital State',
  'right-area-my-oxocard-rename-card': 'Rename Oxocard',
  'right-area-my-oxocard-oxoscript': 'Switch to Oxoscript',

  'right-area-blockly-console-title': 'Here you find the <strong>text messages</strong> you\'ve to sent with your Oxocard to your Blockly (browser).',
  'right-area-blockly-console-note-title': 'Notes:',
  'right-area-blockly-console-note-text1': 'You find the "Send text to console" block in der Extras category.',
  'right-area-blockly-console-clear-data': 'Clear data',
  'right-area-blockly-console-no-data': 'No data',
  'right-area-blockly-console-last-data-value': 'Latest',

  'right-area-blockly-variables-title': 'Here you find the <strong>variables</strong> you\'ve to sent with your Oxocard to your Blockly (browser).',
  'right-area-blockly-variables-note-title': 'Notes:',
  'right-area-blockly-variables-note-text1': 'You find the "Send value to variable" block in der Extras category.',
  'right-area-blockly-variables-note-text2': 'A maximum of 100 values per variable can be saved and displayed.',
  'right-area-blockly-variables-public-link': 'Share link',
  'right-area-blockly-variables-csv-export': 'CSV export',
  'right-area-blockly-variables-clear-data': 'Clear data',
  'right-area-blockly-variables-data-graph': 'Data Graph',
  'right-area-blockly-variables-no-data': 'No data',
  'right-area-blockly-variables-last-data-value': 'Latest',

  'right-area-feedback-title': 'Please give us a feedback, so that we can improve our Oxocard and Blockly:',
  'right-area-feedback-placeholder': 'Your feedback...',
  'right-area-feedback-email-placeholder': 'Your e-mail address (optional)',
  'right-area-feedback-send': 'Send',

  'right-area-worksheet-link-001': 'media/worksheets/A001_Blockly2_eng.pdf',
  'right-area-worksheet-link-002': 'media/worksheets/A002_Blockly2_eng.pdf',
  'right-area-worksheet-link-003': 'media/worksheets/A003_Blockly2_eng.pdf',
  'right-area-worksheet-link-004': 'media/worksheets/A004_Blockly2_eng.pdf',
  'right-area-worksheet-link-005': 'media/worksheets/A005_Blockly2_eng.pdf',
  'right-area-worksheet-link-006': 'media/worksheets/A006_Blockly2_eng.pdf',
  'right-area-worksheet-link-007': 'media/worksheets/A007_Blockly2_eng.pdf',
  'right-area-worksheet-link-008': 'media/worksheets/A008_Blockly2_eng.pdf',
  'right-area-worksheet-link-009': 'media/worksheets/A009_Blockly2_eng.pdf',
  'right-area-worksheet-link-010': 'media/worksheets/A010_Blockly2_eng.pdf',
  'right-area-worksheet-link-011': 'media/worksheets/A011_Blockly2_eng.pdf',
  'right-area-worksheet-link-012': 'media/worksheets/A012_Blockly2_eng.pdf',
  'right-area-worksheet-link-013': 'media/worksheets/A013_Blockly2_eng.pdf',
  'right-area-worksheet-link-014': 'media/worksheets/A014_Blockly2_eng.pdf',
  'right-area-worksheet-link-015': 'media/worksheets/A015_Blockly2_eng.pdf',
  'right-area-worksheet-link-016': 'media/worksheets/A016_Blockly2_eng.pdf',
  'right-area-worksheet-link-017': 'media/worksheets/A017_Blockly2_eng.pdf',
  'right-area-worksheet-link-018a': 'media/worksheets/A018a_Blockly2_eng.pdf',
  'right-area-worksheet-link-018b': 'media/worksheets/A018b_Blockly2_eng.pdf',
  'right-area-worksheet-link-019': 'media/worksheets/A019_Blockly2_eng.pdf',
  'right-area-worksheet-link-020': 'media/worksheets/A020_Blockly2_eng.pdf',
  'right-area-worksheet-link-021': 'media/worksheets/A021_Blockly2_eng.pdf',
  'right-area-worksheet-link-022': 'media/worksheets/A022_Blockly2_eng.pdf',
  'right-area-worksheet-link-023': 'media/worksheets/A023_Blockly2_eng.pdf',
  'right-area-worksheet-link-024': 'media/worksheets/A024_Blockly2_eng.pdf',
  'right-area-worksheet-link-025': 'media/worksheets/A025_Blockly2_eng.pdf',
  'right-area-worksheet-link-026': 'media/worksheets/A026_Blockly2_eng.pdf',
  'right-area-worksheet-link-027': 'media/worksheets/A027_Blockly2_eng.pdf',

  'right-area-news-link-june2019': 'media/news/june_2019_en.pdf',
  'right-area-news-link-september2019': 'media/news/september_2019_en.pdf',
  'right-area-news-link-november2019': 'media/news/november_2019_en.pdf',
  'right-area-news-link-december2019': 'media/news/december_2019_en.pdf',
  'right-area-news-link-august2020': '',
  'right-area-news-link-february2021': 'media/news/february_2021_en.pdf',

  'right-area-instructions-video-link': 'https://www.youtube.com/playlist?list=PLSZShxI-zRnt12wnWJQLNeH1xT0acsMzD',
  'right-area-instructions2018-video-link': 'https://youtu.be/Nk_VvHbkCj4',
  'right-area-instructions-link': 'media/instructions/instructions_2019_en.pdf',
  'right-area-instructions2018-link': '',
  'right-area-instructions-key-commands-link': '',

  'right-area-open-in-oxoscript': 'Open in the Oxoscript editor',

  popupSettingsEditorTitle: 'Configurations',
  popupSettingsEditorPositiveButton: 'Save',
  user_settings_expertModeActive: 'Activate the expert mode',
  user_settings_showInstructions: 'Show help popups',
  user_settings_showAlwaysOldInstructions: '&emsp;&emsp;Show only the old help popups (2018)',
  user_settings_uiLanguageV1: 'Preferred Language',
  user_settings_uiLanguageV1_option_de: 'Deutsch',
  user_settings_uiLanguageV1_option_en: 'English',
  user_settings_uiLanguageV1_option_fr: 'Français',

  defaultPopupTitle: 'Notice',
  defaultPopupPositiveButton: 'OK',
  defaultPopupNegativeButton: 'Cancel',
  defaultPopupContinueButton: 'Continue',

  // no connectivity popup
  popupNoConnectivityTitle: 'You have no Internet connection',
  popupNoConnectivityBody: 'Don\'t worry! As soon as you are reconnected, this window disappears.',

  // API not reachable popup
  popupApiNotReachableTitle: 'Our server doesn\'t seem to be reachable',
  popupApiNotReachableBody: 'You cannot load programs onto your Oxocard at the moment. Please try again in a few minutes.',

  // API reachable again popup
  popupApiReachableAgainTitle: 'Our server seems to be reachable again',
  popupApiReachableAgainBody: 'You can now load programs onto your Oxocard again.',

  // no cards popup
  popupNoCardsTitle: 'No Oxocard is connected',
  popupNoCardsBody: 'Don\'t panic! Would you like to connect one now?',
  popupShareButtonNoCardsBody: 'To be able to share your script, you need to connect an Oxocard.<br>Would you like to connect one now?',
  popupNoCardsNo: 'No',
  popupNoCardsYes: 'Yes, please!',

  // connect popup
  connectPopupTitle: 'Link an Oxocard',
  connectPopupContent: 'Please type in the color combination from your Oxocard.',
  connectPopupConnectButton: 'Connect',

  // connect success popup
  popupConnectSuccessTitle: 'Your Oxocard is now linked!',
  popupConnectSuccessBody: 'Successfully linked the Oxocard.<br />You can now start to program it.',
  popupConnectSuccessOK: 'Nice!',

  // connect error popup
  popupConnectErrorTitle: 'We couldn\'t connect your Oxocard',
  popupConnectErrorBody: 'There was an issue. Would you like to try again?',
  popupConnectErrorNo: 'No, thanks...',
  popupConnectErrorYes: 'Yes, please!',

  // feedback success popup
  popupFeedbackSuccessBody: 'Your feedback is on it\'s way! Thank you very much.',
  popupFeedbackSuccessOK: 'Alright!',

  // feedback failure popup
  popupFeedbackErrorBody: 'Sadly the feedback couldn\'t reach us. May we ask you to send us an email? <a href="mailto:info@oxocard.ch">info@oxocard.ch</a>',
  popupFeedbackErrorClose: 'Close',

  // save before quit popup
  popupSaveBeforeQuitText: 'You have unsaved changes. Are you sure you want to leave?',

  // compilation error popup
  popupCompilationFailedTitle: 'Error while compiling',
  popupCompilationFailedBody: 'Sadly, something went wrong. Are your blockls OK?',

  // flashing error popup
  popupFlashingFailedTitle: 'Error while flashing',
  popupFlashingFailedBody: 'Sadly, something went wrong. Do you want to try again?',
  popupFlashingFailedNo: 'No',
  popupFlashingFailedYes: 'Yes',

  // update available popup
  popupUpdateAvailableTitle: 'A new version is available',
  popupUpdateAvailableBody: 'If you want - and we suggest you do so - you can activate it now.',
  popupUpdateAvailableNo: 'No',
  popupUpdateAvailableYes: 'Yes, please!',

  // unsaved changes popup
  popupUnsavedChangesTitle: 'You have unsaved changes!',
  popupUnsavedChangesBody: 'You are going to lose your changes if you continue. Do you really want to continue?',
  popupUnsavedChangesCancel: 'No!',
  popupUnsavedChangesContinue: 'Continue',

  // really unpair popup?
  popupUnpairTitle: 'You\'re about to unlink your Oxocard.',
  popupUnpairBody: 'You can always reconnect an Oxocard. Do you want to continue?',
  popupUnpairNo: 'No',
  popupUnpairYes: 'Yes!',

  /* Popup - Really reset */
  popup_really_reset_title: 'Do you really want to reset the card?',
  popup_really_reset_body: 'If you click on Reset, all sent data of your Oxocard are deleted. If you place your Oxocard in the update mode afterwards, the default program will be restored.',
  popup_really_reset_cancel: 'No!',
  popup_really_reset_continue: 'Reset',

  /* Popup - Switch to Oxoscript */
  popup_switch_to_oxoscript_title: 'Do you prefer programing with text code?',
  popup_switch_to_oxoscript_body: 'The link with Blockly will be disbanded, if you switch to the Oxoscript editor. You can always switch back.',
  popup_switch_to_oxoscript_cancel: 'Stay in Blockly',
  popup_switch_to_oxoscript_continue: 'Go to the Editor',

  /* Popup - Really clear data */
  popup_really_clear_data_title: 'Do you really want to delete this data?',
  popup_really_clear_data_body: 'If you click on Yes, all data of this variable are irrevocably deleted.',
  popup_really_clear_data_cancel: 'No',
  popup_really_clear_data_continue: 'Yes',

  /* Popup - Really delete variable */
  popup_really_delete_variable_title: 'No data available. Do you want to delete this variable?',
  popup_really_delete_variable_body: 'If you click on Yes, this variable is irrevocably deleted.',
  popup_really_delete_variable_cancel: 'No',
  popup_really_delete_variable_continue: 'Yes',

  // pairing instructions
  popupPairingInstructionsBody: 'Use the displayed combination and sequence of button presses<br />to pair the Oxocard.',
  popupPairingInstructionsCheckbox: 'Do not show this help in the future',

  // pairing instructions 2019
  popupPairingInstructions2019Body: 'Push the above displayed button until the pairing symbol appears.',
  popupPairingInstructions2019Checkbox: 'Do not show this help in the future',

  // stage instructions
  popupUpdatingBody: 'Use the displayed combination and sequence of button presses<br />to update the Oxocard.',
  popupUpdatingCheckbox: 'Do not show this help in the future',
  popupUpdatingButtonCancel: 'Cancel',
  popupUpdatingButtonContinue: 'Continue',

  // Update mode instructions
  popupUpdateModeInstructionsBody: 'Use the displayed combination and sequence of button presses<br />to update the Oxocard.',
  popupUpdateModeInstructionsButtonOK: 'Done',

  // Update mode instructions 2019
  popupUpdateModeInstructions2019Body: 'Push the above displayed button until the update symbol appears.',
  popupUpdateModeInstructions2019ButtonOK: 'Done',

  // invalid block-state popup
  popupInvalidBlocksFailedTitle: 'Your blocks are not arranged correctly',
  popupInvalidBlocksFailedBody: 'You should check all your blocks again.<ul><li>Do you have no or multiple entry-points?</li><li>Do you have blocks, which are not connected correctly?</li><li>Do you have blocks that hide outside of your current workspace view or behind other blocks?</li><li>Do you have undefined (not initialised) variables?</li></ul>',
  popupInvalidBlocksFailedIgnore: 'Ignore',
  popupInvalidBlocksFailedRetry: 'Correct',

  popupDefaultImageSuccessBody: 'The program was provided to the Oxocard. Please put your card into the update-mode to download it.',
  popupDefaultImageSuccessCancel: 'Done',
  popupDefaultImageSuccessOK: 'Update mode',

  popupDefaultImageFailureBody: 'Something went wrong while reseting your card. Please try again.',
  popupDefaultImageFailureOK: 'Close',

  // set name popup
  popupSetNameTitle: 'New Name for your Oxocard',
  popupSetNameSave: 'Save',
  popupSetNameAvailable: 'This name is available.',
  popupSetNameNotAvailable: 'This name is already taken.',
  popupSetNameHint: '<p>You must give your Oxocard a clearly identifiable name. This allows you to communicate more easily with your Oxocard friends.</p><p>Unfortunately, your Oxocard does not have a unique name at the moment. You can now create an anonymized name or choose one yourself.</p>',
  popupSetNameRules: '<p>Please note the following rules:<p><ul><li>No space bar</li><li>No special characters</li><li>Minimum 4, maximum 30 characters long</li><li>Minimum one Number</li></ul>',
  popupSetNameNotValid: 'The name does not fulfill our rules!',
  popupSetNameRandom: 'Random',
  popupSetNameLabel: 'New name',

  // set name success popup
  popupSetNameSuccessTitle: 'Your oxocard has been renamed',
  popupSetNameSuccessBody: 'You have successfully renamed the Oxocard.<br />You can now start programming.',
  popupSetNameSuccessOK: 'Awesome!',

  // set name error popup
  popupSetNameErrorTitle: 'Unfortunately we couldn\'t rename your Oxocard.',
  popupSetNameErrorBody: 'There was a problem. Do you want to try it again?',
  popupSetNameErrorNoClient: 'There was a problem with the data structure of your Oxocard. That means you have to reconnect your Oxocard.',
  popupSetNameErrorNo: 'No, thanks...',
  popupSetNameErrorYes: 'Yes please!',

  // publish script popup
  popupShareCodeTitle: 'Your link has been created!',
  popupShareCodeBody: 'Share it with your friends or save it as a bookmark.',
  popupShareCodeCloseButton: 'Close',
  popupShareCodeCopyButton: 'Copy Link',
  popupShareCodeCopyButtonFeedbackPositive: 'Link was copied!',
  popupShareCodeCopyButtonFeedbackNegative: 'Link wasn\'t copied!',
  popupShareCodeEmailButton: 'Share via email',
  publishScriptEmailSubject: 'Have a look at my script',

  popupShareCodeFailedTitle: 'Something went wrong',
  popupShareCodeFailedBody: 'Sadly, we couldn\'t create a link for you. Please retry later.',
  popupShareCodeFailedButton: 'Close',

  // invalid hash popup
  popupInvalidHashTitle: 'The script couldn\'t be openend',
  popupInvalidHashBody: 'The reason may be that the link isn\'t correct. It is also possible that it expired already.',
  popupInvalidHashClose: 'Close',

  // firmware selection
  popupFirmwareSelectionTitle: 'What firmware version has your oxocard?',
  popupFirmwareSelectionBody2019: '<h3><b>Version 2019</b></h3><p>If you see the animated Oxocard logo after a reset, push the button below.</p>',
  popupFirmwareSelectionBody2018: '<h3><b>Version 2018</b></h3><p>If you directly see a smiley or the Oxocard logo fading in after a reset, push the button below.</p>',
  popupFirmwareSelectionButton: 'Push here',

  // old firmware version
  popupOldFwVersionTitle: 'Your Oxocard is now linked!',
  popupOldFwVersionMessage: 'However, you have to update your Oxocard before you can start. Please download the latest firmware by putting your Oxocard into the update mode. Then you have to re-link your Oxocard.',

  // news
  news: 'News',
  newsJune2019LinkPDF: 'June 2019',
  newsSeptember2019LinkPDF: 'September 2019',
  newsNovember2019LinkPDF: 'November 2019',
  newsDecember2019LinkPDF: 'December 2019',
  newsAugust2020LinkPDF: '',
  newsFebruary2021LinkPDF: 'February 2021',
  newsLastUpdate: 'Last update',

  // instructions
  instructions: 'First steps to install the Oxocard',
  instructionsButtonVideo: 'Video',
  instructionsButtonPDF: 'Instruction (PDF)',
  instructions2018LinkPDF: '',
  instructions2018LinkVideo: '',
  instructionsKeyCommands: '',
  instructionsTitle: 'Blockly briefly explained',
  instructions01: 'On the left, you can select single blocks within the various categories and drag them into the central workspace.',
  instructions02: 'If you click and hold into the workspace, all blocks can be moved simultaneously.',
  instructions03: 'A blockly program starts at the top and ends at the bottom. The blocks will be executed one after another.',
  instructions04: 'All blocks must be connected (clicked together).',
  instructions05: 'As soon as the last block was executed, the Oxocard turns off. If your program never reaches a final block due to a loop, the card automatically turns off after two minutes.',
  instructions06: 'If you push the buttons L2 (bottom left outside) and L3 (bottom left inside) together for a short time, the Oxocard is resetting.',
  instructions07: 'If you push and hold the button L1 (top left) and then push the buttons R2 (bottom right outside) and R3 (bottom right inside) together for a short time, the Oxocard is turning off.',
  instructions08: 'In the settings you can activate all available blocks for the Oxocard (expert blocks).',

  // worksheet templates
  worksheetTemplate01: 'Worksheet 01 - Pixel Image',
  worksheetTemplate02: 'Worksheet 02 - Moving Text',
  worksheetTemplate03: 'Worksheet 03 - Animation',
  worksheetTemplate04: 'Worksheet 04 - Colours',
  worksheetTemplate05: 'Worksheet 05 - Graphic Commands',
  worksheetTemplate06: 'Worksheet 06 - Smiley-Machine',
  worksheetTemplate07: 'Worksheet 07 - Multiplication table',
  worksheetTemplate08: 'Worksheet 08 - Conditions',
  worksheetTemplate09: 'Worksheet 09 - Random',
  worksheetTemplate10: 'Worksheet 10 - Piano',
  worksheetTemplate11: 'Worksheet 11 - Acceleration',
  worksheetTemplate12: 'Worksheet 12 - Angle',
  worksheetTemplate13: 'Worksheet 13 - Kaleidoscope',
  worksheetTemplate14: 'Worksheet 14 - Cursor',
  worksheetTemplate15: 'Worksheet 15 - Weather',
  worksheetTemplate16: 'Worksheet 16 - Alarm',
  worksheetTemplate17: 'Worksheet 17 - Microphone',
  worksheetTemplate18a: 'Worksheet 18a - Send',
  worksheetTemplate18b: 'Worksheet 18b - Receive',
  worksheetTemplate19: 'Worksheet 19 - List',
  worksheetTemplate20: 'Worksheet 20 - Functions',
  worksheetTemplate21: 'Worksheet 21 - Simple Snake',
  worksheetTemplate22: 'Worksheet 22 - Local communication',
  worksheetTemplate23: 'Worksheet 23 - Local communication 2 *',
  worksheetTemplate24: 'Worksheet 24 - Global communication *',
  worksheetTemplate25: 'Worksheet 25 - Traffic light',
  worksheetTemplate26: 'Worksheet 26 - Sensor data',
  worksheetTemplate27: 'Worksheet 27 - Print',

  communicationWorksheets: '* You will need two Oxocards for these worksheets',

  // worksheet solutions
  worksheetSolution01: 'Solution 01 - Pixel Image',
  worksheetSolution02: 'Solution 02 - Moving Text',
  worksheetSolution03: 'Solution 03 - Animation',
  worksheetSolution04: 'Solution 04 - Colours',
  worksheetSolution05: 'Solution 05 - Graphic Commands',
  worksheetSolution06: 'Solution 06 - Smiley-Machine',
  worksheetSolution07: 'Solution 07 - Multiplication table',
  worksheetSolution08: 'Solution 08 - Conditions',
  worksheetSolution09: 'Solution 09 - Random',
  worksheetSolution10: 'Solution 10 - Piano',
  worksheetSolution11: 'Solution 11 - Acceleration',
  worksheetSolution12: 'Solution 12 - Angle',
  worksheetSolution13: 'Solution 13 - Kaleidoscope',
  worksheetSolution14: 'Solution 14 - Cursor',
  worksheetSolution15: 'Solution 15 - Weather',
  worksheetSolution16: 'Solution 16 - Alarm',
  worksheetSolution17: 'Solution 17 - Microphone',
  worksheetSolution18a: 'Solution 18a - Send',
  worksheetSolution18b: 'Solution 18b - Receive',
  worksheetSolution19: 'Solution 19 - List',
  worksheetSolution20: 'Solution 20 - Functions',
  worksheetSolution21: 'Solution 21 - Simple Snake',
  worksheetSolution22: 'Solution 22 - Local communication',
  worksheetSolution23: 'Solution 23 - Local communication 2',
  worksheetSolution24: 'Solution 24 - Global communication',
  worksheetSolution25: 'Solution 25 - Traffic light',
  worksheetSolution26: 'Solution 26 - Sensor data',
  worksheetSolution27: 'Solution 27 - Print',

  // booklet exercises
  bookletExerciseTemplate01: 'Exercise 01 - Monochrome image',
  bookletExerciseTemplate02: 'Exercise 02 - Animation',
  bookletExerciseTemplate03a: 'Exercise 03a - Graphics commands',
  bookletExerciseTemplate03b: 'Exercise 03b - Graphics commands',
  bookletExerciseTemplate03c: 'Exercise 03c - Graphics commands',
  bookletExerciseTemplate04: 'Exercise 04 - Flower',
  bookletExerciseTemplate05a: 'Exercise 05a - Smiley Machine',
  bookletExerciseTemplate05b: 'Exercise 05b - Smiley by tilt',
  bookletExerciseTemplate06: 'Exercise 06 - Countdown',
  bookletExerciseTemplate07: 'Exercise 07 - Number series',
  bookletExerciseTemplate08: 'Exercise 08 - Animation with a loop',
  bookletExerciseTemplate09: 'Exercise 09 - Colorize the picture',
  bookletExerciseTemplate10a: 'Exercise 10a - Melody',
  bookletExerciseTemplate10b: 'Exercise 10b - Piano',
  bookletExerciseTemplate11: 'Exercise 11 - Sounds',
  bookletExerciseTemplate12: 'Exercise 12 - Dice machine',
  bookletExerciseTemplate13: 'Exercise 13 - Random Pixel',
  bookletExerciseTemplate14: 'Exercise 14 - Random Sounds',
  bookletExerciseTemplate15: 'Exercise 15 - Falling Pixel',
  bookletExerciseTemplate16: 'Exercise 16 - Calculated randomness',
  bookletExerciseTemplate17: 'Exercise 17 - Tilting and rolling',
  bookletExerciseTemplate18: 'Exercise 18 - Catch-the-Pixel',
  bookletExerciseTemplate19a: 'Exercise 19a - Simple watch',
  bookletExerciseTemplate19b: 'Exercise 19b - Simple watch (extra task)',
  bookletExerciseTemplate20_s: 'Exercise 20 - Short messages (send)',
  bookletExerciseTemplate20_r: 'Exercise 20 - Short messages (receive)',

  // booklet solutions
  bookletExerciseSolution01: 'Solution 01 - Monochrome image',
  bookletExerciseSolution02: 'Solution 02 - Animation',
  bookletExerciseSolution03a: 'Solution 03a - Graphics commands',
  bookletExerciseSolution03b: 'Solution 03b - Graphics commands',
  bookletExerciseSolution03c: 'Solution 03c - Graphics commands',
  bookletExerciseSolution04: 'Solution 04 - Flower',
  bookletExerciseSolution05a: 'Solution 05a - Smiley Machine',
  bookletExerciseSolution05b: 'Solution 05b - Smiley by tilt',
  bookletExerciseSolution06: 'Solution 06 - Countdown',
  bookletExerciseSolution07: 'Solution 07 - Number series',
  bookletExerciseSolution08: 'Solution 08 - Animation with a loop',
  bookletExerciseSolution09: 'Solution 09 - Colorize the picture',
  bookletExerciseSolution10a: 'Solution 10a - Melody',
  bookletExerciseSolution10b: 'Solution 10b - Piano',
  bookletExerciseSolution11: 'Solution 11 - Sounds',
  bookletExerciseSolution12: 'Solution 12 - Dice machine',
  bookletExerciseSolution13: 'Solution 13 - Random Pixel',
  bookletExerciseSolution14: 'Solution 14 - Random Sounds',
  bookletExerciseSolution15: 'Solution 15 - Falling Pixel',
  bookletExerciseSolution16: 'Solution 16 - Calculated randomness',
  bookletExerciseSolution17: 'Solution 17 - Tilting and rolling',
  bookletExerciseSolution18: 'Solution 18 - Catch-the-Pixel',
  bookletExerciseSolution19a: 'Solution 19a - Simple watch',
  bookletExerciseSolution19b: 'Solution 19b - Simple watch (extra task)',
  bookletExerciseSolution20_s: 'Solution 20 - Short messages (send)',
  bookletExerciseSolution20_r: 'Solution 20 - Short messages (receive)',

  // example titles
  exampleTitleSimple: 'Simple',
  exampleTitleAdvanced: 'Advanced',
  exampleTitleExpert: 'Expert (Games)',

  // examples
  exampleNameSmiley: 'Smiley',
  exampleTemplateSmiley: 'Example - Smiley',
  exampleNameWink: 'Wink',
  exampleTemplateWink: 'Example - Wink',
  exampleNameFalling_pixel: 'Falling Pixel',
  exampleTemplateFalling_pixel: 'Example - Falling Pixel',
  exampleNameKaleidoscope: 'Kaleidoscope',
  exampleTemplateKaleidoscope: 'Example - Kaleidoscope',
  exampleNamePiano: 'Piano',
  exampleTemplatePiano: 'Example - Piano',
  exampleNameSimple_communication: 'Simple communication (2 cards necessary)',
  exampleTemplateSimple_communication: 'Example - Simple communication',
  exampleNameRainbow: 'Rainbow',
  exampleTemplateRainbow: 'Example - Rainbow',
  exampleNameWeather: 'Weather',
  exampleTemplateWeather: 'Example - Weather',
  exampleNameBattery: 'Battery',
  exampleTemplateBattery: 'Example - Battery',
  exampleNameHangman: 'Hangman',
  exampleTemplateHangman: 'Example - Hangman',
  exampleNameMoving_pixel: 'Moving pixel',
  exampleTemplateMoving_pixel: 'Example - Moving pixel',
  exampleNameRain: 'Rain',
  exampleTemplateRain: 'Example - Rain',
  exampleNameLong_image: 'Long image',
  exampleTemplateLong_image: 'Example - Long image',
  exampleNameWhistle: 'Whistle',
  exampleTemplateWhistle: 'Example - Whistle',
  exampleNameNoise_meter: 'Noise meter',
  exampleTemplateNoise_meter: 'Example - Noise meter',
  exampleNameLocal_communication: 'Local communication (2 cards necessary)',
  exampleTemplateLocal_communication: 'Example - Local communication',
  exampleNameGlobal_communication: 'Global communication (2 cards necessary)',
  exampleTemplateGlobal_communication: 'Example - Global communication',
  exampleNameCarousel: 'Carousel game',
  exampleTemplateCarousel: 'Example - Carousel game',
  exampleNamePainter: 'Painter',
  exampleTemplatePainter: 'Example - Painter',
  exampleNameColor_game: 'Simon says',
  exampleTemplateColor_game: 'Example - Simon says',
  exampleNameDrop_game: 'Drop the Game',
  exampleTemplateDrop_game: 'Example - Drop the Game',
  exampleNameRock_Paper_Scissors: 'Rock-Paper-Scissors (2 cards necessary)',
  exampleTemplateRock_Paper_Scissors: 'Example - Rock-Paper-Scissors',
  exampleNameMini_Pong: 'Mini Pong',
  exampleTemplateMini_Pong: 'Example - Mini Pong',

  // Editor
  settingsFeatureIntroTitle: 'Show feature introduction on startup?',
  settingsFeatureIntroNew: 'New Changes',
  settingsFeatureIntroAlways: 'Show always',
  settingsFeatureIntroNever: 'Show never',
  feedback: 'Please give us a feedback, so that we can improve our Oxocard and the Editor:',
  rebootCard: 'Reboot Card',
  shutDownCard: 'Shut Down Card',
  documentation: 'Documentation',
  searchDocumentation: 'Search docs...',
  clearOutput: 'Clear',
  output: 'Output',
  cmdTimedOutTitle: 'Command timed out.',
  cmdTimedOutMsg: 'Is your oxocard connected?',
  wsConnection: 'WS Connection',
  cardConnection: 'Card Connection',
  editorMenuTitle: 'Editor',
  editorThemeLight: 'Light',
  editorThemeDark: 'Dark',
  settingsEditorTheme: 'Change editor theme:',
  toasts: {
    wsOpenSuccess: 'Websocket connection established',
    wsOpenFail: 'We could not open a Websocket connection',
    cardOpen: 'Connection to your card established',
    cardClose: 'We lost connection to your card',
    cardPairSuccess: 'Successfully paired with your card',
    cardPairFail: 'We could not pair with your card',
    feedbackSuccess: 'Thanks for your feedback',
    feedbackFail: 'We could not send your feedback',
    runFileResponse: 'Run file response. Click to see more.',
    runFileError: 'Could not execute program',
    runFileSuccess: 'Program successfully executed',
  },
  legacyVersionPopupTitle: 'Outdated Version',
  legacyVersionPopupBody: 'It looks like you have an outdated software version on your Oxocard. In order to use the editor, you need to update your Oxocard first.',

  errorCode0: 'After \'def\' you have to define a function name.',
  errorCode1: 'There is a missing \'(\'-symbol.',
  errorCode2: 'There is a missing \')\'-symbol.',
  errorCode3: 'Variables need a data-type. Choose between \'int\', \'char\', or \'byte\'',
  errorCode4: 'There is a missing or unknown statement.',
  errorCode5: '\'=\', \'(\' or \'+=\' expected.',
  errorCode6: '\'++\' or \'--\' expected.',
  errorCode7: 'Unknown function name. Check the spelling of the name.',
  errorCode8: 'There is a missing \'(\'-symbol.',
  errorCode9: 'There is a missing \')\'-symbol.',
  errorCode10: 'Numeric value expected.',
  errorCode11: 'The function expects a list variable or a string, but you pass an int/char/byte variable',
  errorCode12: 'This function has no parameters, but you tried to passed some values.',
  errorCode13: 'You passed a wrong number of parameters.',
  errorCode14: '\']\' expected.',
  errorCode15: 'Return is not value in event procedures. Use \'exit\' instead.',
  errorCode16: 'There is a missing \')\'-symbol.',
  errorCode17: 'The variable is not declared. Check the spelling.',
  errorCode18: '] expected but not found.',
  errorCode19: 'You have to use a list type here.',
  errorCode20: 'There is a missing \')\'-symbol.',
  errorCode21: 'There was an error in a expression.',
  errorCode22: 'There is a missing \')\'-symbol.',
  errorCode23: 'There is a missing \')\'-symbol.',
  errorCode24: 'Each statement must be terminated by a Newline or a semicolon (\';\')',
  errorCode25: 'You cannot set a value here on global variables. Only allowed in functions.',
  errorCode26: 'Place a colon (\':\') here with indentation.',
  errorCode27: 'Error in for-statement: for IDENT in list: statements',
  errorCode28: 'Use a simple variable after \'for\', list types are not allowed here.',
  errorCode29: '\'in\' expected.',
  errorCode30: 'Indexed access requires a known/declared variable.',
  errorCode31: 'After for ..in - a list, integer variable or a number is expected.',
  errorCode32: 'Array types are not allowed here.',
  errorCode33: '\'=\' expected.',
  errorCode34: 'This variable is already in use.',
  errorCode35: 'Global numeric variables can only initialize to 0.',
  errorCode36: 'Global list variables can only initialize to [].',
  errorCode37: 'Def functions or global variable declarations expected.',
  errorCode38: 'Comma expected.',
  errorCode39: 'After a colon, the lines must be indented.',
};
